// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__3Osv9","profile":"Dashboard_profile__pTToF","databox":"Dashboard_databox__1IZmh"};